import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import { useBucket } from '../_load/BucketLoader'
import { usePdfOptionsForm } from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Page from '../../../../components/pdf/Page'
import Panel from '../../../../components/structure/Panel'
import QrcodeWithTemplate from './QrcodeWithTemplate'
import QrcodeWithoutTemplate from './QrcodeWithoutTemplate'
import Separator from '../../../../components/helpers/Separator'

const PREVIEW_LENGTH = 8

const Item = ({ qrcode, hasTemplate }) => {
  if (hasTemplate) return <QrcodeWithTemplate qrcode={qrcode} />
  return <QrcodeWithoutTemplate qrcode={qrcode} />
}

const QrcodesGrid = () => {
  const form = usePdfOptionsForm()
  const bucket = useBucket()
  let qrcodes = bucket.qrcodes
  const preview = form.preview && qrcodes.length > PREVIEW_LENGTH

  if (preview) {
    qrcodes = bucket.qrcodes.slice(0, PREVIEW_LENGTH)
  }

  return (
    <Page>
      {qrcodes.map(qrcode => (
        <Item key={qrcode.id} qrcode={qrcode} hasTemplate={!!form.svgTemplate || !!form.Component} />
      ))}

      {preview && (
        <>
          <Separator weight={8} />
          <Panel noMargin bgColor={COLORS.orange} noShadow smallPadding>
            <Text color={COLORS.white} align="center">
              Editor de template mostrando {PREVIEW_LENGTH} dos {bucket.qrcodes.length} qrcodes
            </Text>
          </Panel>
        </>
      )}
    </Page>
  )
}

export default QrcodesGrid
